let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("yVxyC")).then(() => parcelRequire('3aFim'));